// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"_39k39tn6M8B7ovJIq2biiE"};